<script setup lang="ts">
  import { useAccessRoleDetailProvider } from '../providers/access-role-detail-context'
  import {
    Tooltip,
    TooltipTrigger,
    TooltipContent,
    TooltipProvider,
    useModalStack
  } from '@gat-ship/vue-components'
  import { IconUsers, IconBan } from '@gat-ship/icons'
  import {
    Avatar,
    AvatarFallback,
    AvatarImage,
    Separator
  } from '@gat-ship/vue-components'

  const { dataSource } = useAccessRoleDetailProvider()
  const stack = useModalStack()

  const maxUsersToShow = 10
</script>

<template>
  <div
    class="bg-background shadow-xs ring-border flex w-full shrink-0 grow-0 flex-col gap-2 self-start rounded-sm p-2.5 text-xs ring-1 ring-inset"
  >
    <div
      class="text-muted-foreground flex flex-wrap items-center gap-2 font-medium"
    >
      <icon-users class="size-4 rounded-full" />
      Users with this role
    </div>
    <separator />
    <div class="text-muted-foreground flex flex-wrap gap-2 text-xs">
      <span v-if="dataSource.usersWithAccessRole.value.length === 0"
        >No users.</span
      >
      <template
        v-for="user in dataSource.usersWithAccessRole.value.slice(
          0,
          maxUsersToShow
        )"
        :key="user.userId"
      >
        <TooltipProvider>
          <tooltip>
            <TooltipTrigger
              class="flex cursor-pointer"
              @click="stack.open('tenant-user', { id: user.userId })"
            >
              <div class="relative" :aria-label="user.userFullName">
                <Avatar class="relative size-8 rounded-full">
                  <AvatarImage
                    v-if="user.userImageUrl"
                    :src="user.userImageUrl"
                  />
                  <AvatarFallback>{{
                    user.userFullName.slice(0, 2)
                  }}</AvatarFallback>
                </Avatar>
                <IconBan
                  v-if="!user.isActive"
                  class="text-destructive absolute left-0 top-0 size-4"
                />
              </div>
            </TooltipTrigger>
            <TooltipContent>
              {{ user.userFullName }}
            </TooltipContent>
          </tooltip>
        </TooltipProvider>
      </template>
    </div>
  </div>
</template>
